module.exports = __webpack_public_path__ + "static/media/hd-mountain-bg.f24c405e.jpg";